import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cssPosition } from '../helpers';
import './style.scss';
export default function Food(_ref) {
  var gridSize = _ref.gridSize,
      position = _ref.position,
      eaten = _ref.eaten,
      big = _ref.big;
  var className = classNames('food', {
    eaten: eaten,
    big: big
  });
  var style = cssPosition(position, gridSize);
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    style: style
  });
}
Food.propTypes = {
  gridSize: PropTypes.number.isRequired,
  position: PropTypes.array.isRequired,
  eaten: PropTypes.bool.isRequired,
  big: PropTypes.bool.isRequired
};